const gender = {
  male: 'Male',
  female: 'Female',
  other: 'Other',
  wontSpecify: "Won't Specify",
};

export default gender;
